import { useEffect, useState } from "preact/hooks";

const THEME_KEY = "theme";

function getResolvedTheme(): "dark" | "light" {
  const savedTheme = globalThis.localStorage?.getItem(THEME_KEY);

  if (savedTheme === "dark" || savedTheme === "light") {
    return savedTheme;
  }

  return "dark";
}

function applyTheme(theme: "dark" | "light") {
  const root = globalThis.document?.documentElement;
  if (!root) return;

  root.classList.toggle("dark", theme === "dark");
  globalThis.localStorage?.setItem(THEME_KEY, theme);
}

export default function DarkModeToggle() {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    const resolvedTheme = getResolvedTheme();
    setIsDark(resolvedTheme === "dark");
    applyTheme(resolvedTheme);
  }, []);

  const toggleDarkMode = () => {
    const currentTheme = document.documentElement.classList.contains("dark")
      ? "dark"
      : "light";
    const nextTheme = currentTheme === "dark" ? "light" : "dark";

    applyTheme(nextTheme);
    setIsDark(nextTheme === "dark");
  };

  return (
    <button
      onClick={toggleDarkMode}
      class={`fixed top-4 right-4 z-50 p-3 rounded-full shadow-lg transition-all duration-200 border ${
        isDark
          ? "bg-gray-800 hover:bg-gray-700 text-gray-300 hover:text-white border-gray-700"
          : "bg-white hover:bg-gray-100 text-gray-700 hover:text-gray-900 border-gray-300"
      }`}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? (
        <i class="fas fa-sun text-yellow-400"></i>
      ) : (
        <i class="fas fa-moon text-blue-400"></i>
      )}
    </button>
  );
}
